export default __webpack_public_path__ + "assets/lamina-sc-component.d5408441.svg";